export enum TicketsSortingOption {
    Default = "recommended",
    PriceAscending = "price_ascending",
    PriceDescending = "price_descending",
    WinAscending = "win_ascending",
    WinDescending = "win_descending",
}
